module.exports = __webpack_public_path__ + "img/icon_aside_ppt3.f08fdbaa.svg";